import { render, staticRenderFns } from "./richCellText.vue?vue&type=template&id=acf5895e&scoped=true&"
import script from "./richCellText.vue?vue&type=script&lang=js&"
export * from "./richCellText.vue?vue&type=script&lang=js&"
import style0 from "./richCellText.vue?vue&type=style&index=0&id=acf5895e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/.pnpm/vue-loader@15.9.6_kq6vcxhoovkpo5ecbydii27d4a/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "acf5895e",
  null
  
)

export default component.exports